import dayjs from 'dayjs';

export const getUnixTimestamp = (time: string) => {
  const date = dayjs(time);
  if (date.isValid()) return date.unix();
  return undefined;
};
